// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-header {
   background: #2ab4c0;
   height: 60px;
   padding: 0 15px 0 10px;
}
.preview-header .back-button {
   background: transparent;
   border: none;
   color: rgba(255, 255, 255, .7);
   cursor: pointer;
   outline: none;
   width: 32px;
   height: 32px;
}

.file-action {
   justify-content: flex-end;
}
.file-action button + button {
   margin-left: 1em;
}
.file-action button.mat-button, .file-action button.mat-raised-button {
   line-height: 28px;
   min-width: 80px;
   padding: 0 12px;
}

.image-viewer {
   overflow: auto;
}
.image-viewer img {
   background: #fff;
   max-width: 100%;
   max-height: 100%;
}
.image-viewer::ng-deep svg {
   width: 100%;
}
.text-viewer {
   overflow: auto;
   padding: 1em;
   white-space: pre-wrap;
}
.mail-viewer {
   padding: 1em;
}
.mail-viewer table, .mail-viewer iframe {
   border-collapse: collapse;
   border: none;
   width: 100%;
   height: 100%;
}
iframe {
   border-collapse: collapse;
   border: none;
   width: 100%;
   z-index: 1;
}
.mail-viewer td:first-child {
   padding: 3px 5px;
   text-align: right;
   width: 80px;
}
.mail-viewer td:last-child {
   padding: 3px 5px;
}
.address::ng-deep b {
   color: #222;
   font-weight: normal;
}
.mail-viewer .body {
   height: 100%;
   width: 100%;
   vertical-align: top;
}
.mail-viewer td.attachment {
   padding: 3px;
}
.mail-viewer .attachment div {
   display: inline-block;
   margin-right: 1em;
   line-height: 2;
}
.mail-viewer a {
   color: #ba68c8;
   cursor: pointer;
}
/*::ng-deep .body a {*/
   /*color: #2ab4c0;*/
/*}*/
.mail-viewer td:first-child {
   color: #222;
}
.mail-viewer td.text {
   padding: 0;
}
.mail-viewer td.html {
   padding: 10px 0 0;
}
.mail-viewer .subject, .mail-viewer .fit {
   background: #fff;
   border: 1px solid #ececec;
   border-radius: 3px;
   box-shadow: inset 0 0 6px rgba(0,0,0,.05);
   padding: 3px 5px;
   white-space: pre-wrap;
}
.body iframe {
   border: 1px solid #f4f5f7;
   border-radius: 3px;
}
.mail-viewer .fit {
   height: 100%;
   overflow: auto;
   padding: .5em 1em;
}
audio {
   min-width: 80%;
   visibility: hidden;
}
.video-viewer {
   background-color: black;
}
video {
   max-width: 100%;
   max-height: 100%;
   visibility: hidden;
}
.visible {
   visibility: visible;
}

.can-not-preview {
   padding: 2em;
   text-align: center;
}
.preview-icon {
   opacity: .7;
   width: 160px;
   height: 160px;
   margin: auto;
}
.preview-error {
   color: #1b2733;
   font-size: 18px;
   margin: 8px;
}
.preview-error-info {
   color: #637282;
}
.preview-error-info span {
   margin: 0 8px;
}
.can-not-preview button {
   margin: 8px;
}


.info {
   background: #fff;
   width: 320px;
   min-width: 320px;
   overflow-y: auto;
   transition: margin-right .2s;
}
.section-header {
   border-bottom: 1px solid #eaeaea;
   color: #222;
   padding-bottom: 10px;
   margin: 30px 0 10px;
}
.info .properties {
   font-size: 13px;
   line-height: 16px;
   margin: 0;
   padding: 0;
}
.info .edit {
   color: #2ab4c0;
   cursor: pointer;
   font-size: 13px;
   font-weight: 300;
}
.info label,
.info dl dt {
   color: #777;
   display: block;
   margin: 20px 0 0;
   padding-bottom: 3px;
}
.info dl dd {
   color: #444;
   margin: 0 0 20px;
   word-break: break-all;
}
.info input,
.info textarea {
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   font-size: 13px;
   outline: none;
   padding: 3px 6px;
   resize: none;
   width: 100%;
}

.select-types {
   padding-bottom: 10px;
   margin: 30px 0 10px;
   width: 100%;
}
.save-metadata {
   margin-top: 20px;
   text-align: right;
   margin-right: 5px;
}
.save-button {
   line-height: 1.7;
   min-width: inherit;
   padding: 0 1em;
}


mat-tab-group {
   width: 100%;
}
.info::ng-deep .mat-tab-label {
   height: auto;
   line-height: 36px;
   min-width: inherit;
   padding: 0 1em;
}
.info::ng-deep .mat-tab-body-wrapper {
   flex: 1;
}
.info::ng-deep .mat-tab-body-content {
   display: flex;
   flex-direction: column;
   padding: 0 0 1em 1em;
}
.example-header-image {
   background-image: url('profile.png');
   background-size: cover;
}
.commentItem:hover .delComment {
   display: block;
}
.delComment {
   display: none;
}

.comments-container {
   overflow-y: auto;
}
.no-comment {
   padding: 1em;
}
.comments-container ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.comments-container li {
   margin-top: 1em;
}
.comment-item {
   line-height: 20px;
   margin-left: 48px;
   position: relative;
}
.comment-item a {
   cursor: pointer;
   white-space: nowrap;
   width: 200px;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
}
.comment-item .avatar {
   float: left;
   margin-left: -48px;
   margin-top: 3px;
   width: 36px;
   height: 36px;
   border-radius: 50%;
   object-fit: cover;
}
.comment-item .time {
   color: #657786;
   font-size: 12px;
}
.comment-item .time:before {
   content: "\\00b7";
   padding: 0 5px;
}
.comment-item .delete {
   color: #999;
   cursor: pointer;
   position: absolute;
   top: 0;
   right: 0;
   font-size: 20px;
   width: 20px;
   height: 20px;
   display: none;
}
.comment-item:hover .delete {
   display: block;
}
.comment-item .delete:hover {
   color: #d32f2f;
}
.add-comment {
   text-align: right;
   margin: 5px 10px 0 0;
}
.add-comment textarea {
   display: block;
}
.add-comment button {
   margin-top: .5em;
   padding: 1px 16px;
   line-height: initial;
   min-width: 64px;
}

.relative {
   position: relative;
}
.page-notfound {
   text-align: center;
   padding: 10em;
   height: 0;
}
.page-notfound-error {
   color: #1b2733;
   font-size: 30px;
   margin: 8px;
}
.page-notfound-icon {
   opacity: .7;
   width: 200px;
   height: 200px;
   margin: auto;
}
.page-notfound input {
   padding: 8px;
   margin: 10px 0;
}
.page-password-icon {
   opacity: .7;
   width: 200px;
   height: 200px;
   margin: auto;
}
.page-password-text {
   font-size: 18px;
   margin: 10px;
}
.img-center {
   display: flex; /*for IE*/
   /*display: -webkit-box;*/
   align-items: center;
   justify-content: center;
}

.slide-right {
   margin-right: -320px;
   display: none;
}

.editing .item-content, .textarea-content {
   display: none;
}
.editing .textarea-content {
   display: block;
}
.textarea-content {
   margin-top: 5px;
   margin-right: 10px;
}
.edit2, .delete2 {
   color: #999;
   vertical-align: middle;
   font-size: 16px;
   text-align: center;
   display: none;
   cursor: pointer;
}
.delete2:hover {
   color: #d32f2f;
}
.edit2:hover {
   color: #00bed6;
}
.comment-item:hover .delete2, .comment-item:hover .edit2  {
   display: table-cell;
}
.mat-button {
   min-width: 0px;
}
.mat-button.save {
   color: #00bed6;
}
.textarea-content div {
   text-align: right;
}
.btn-comment {
   position: absolute;
   top: 0;
   right: 0;
}
.item-content {
   word-wrap: break-word;
   white-space: pre-line
}
.form {
   margin-right: 5px;
}
.author-name {
   margin-right: 4em;
   word-wrap: break-word;
   white-space: pre-line;
}
.description {
   margin-right: 10px;
}

.empty-folder-share {
   flex-direction: column;
   margin-right: 2em;
   text-align: center;
}
.empty-folder-share img {
   width: 150px;
   height: 150px;
   opacity: .6;
   filter: grayscale(10%);
}
.empty-folder-share h4 {
   font-size: 20px;
   margin: 0 0 10px;
}

.browse-folder {
   display: inline-block;
   margin-right: 5px;
   width: 24px;
   height: 24px;
   vertical-align: text-bottom;
}

.menu-share {
   list-style: none;
}

.toolbar {
   align-items: center;
}

.menu-share>li {
   float: left;
}

.menu-share>li+li {
   margin-left: 1em;
}

.menu-share>li>a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu-share>li>a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open>a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu-share i {
   font-size: 16px;
}

.menu-share i+span {
   margin-left: 10px;
}

.menu-share span+i {
   margin-left: 10px;
}

.menu-share button {
   min-width: 0;
   padding: 0 12px;
}

.menu-share button.mat-primary {
   line-height: 30px;
}

.menu-share button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.drag-over {
   background-color: rgba(0, 188, 212, .2);
   opacity: .5;
}

.bc-view-share {
   color: #fff;
   font-size: 16px;
   font-weight: 400;
   margin: 0;
   padding: 0;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.preview-header-share {
   background: #fff;
   height: 60px;
   padding: 0 15px 0 10px;
   align-items: center;
   box-shadow: #0000000d 0 1px 2px, #0000000d 0 1px 4px, #0000000d 0 2px 8px;
}
.preview-header-share .back-button {
   background: transparent;
   border: none;
   color: rgba(0, 0, 0, .4);
   cursor: pointer;
   outline: none;
   width: 32px;
   height: 32px;
}

.doc-title-modified-share {
   font-size: 12px;
   margin-top: 3px;
}

.doc-title-share {
   margin: 0 15px 0 10px;
}

.doc-title-share h1 {
   font-size: 16px;
   font-weight: normal;
   margin: 0;
   padding: 0;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.img-logo {
   margin-left: 10px;
   height: 24px;
}

.img-logo.custom {
   height: 32px;
}

.sidebar-toggle-share {
   cursor: pointer;
   display: inline-block;
   fill: rgba(0, 0, 0, .5);
   margin-left: 1em;
   min-width: 12px;
   min-height: 10px;
}

.powered-by {
   position: fixed;
   left: 0;
   right: 0;
   bottom: 0;
   transition: left .4s;
   z-index: 999;
}

.breadcrumb1-share {
   font-size: 18px;
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
   color: rgba(0, 0, 0, .5);
}

.breadcrumb1-share li:first-child {
   display: inline-block;
   white-space: nowrap;
}

.breadcrumb1-share li:not(:first-child) {
   overflow: hidden;
}

.breadcrumb1-share li:last-child {
   flex: 1;
   min-width: 50px;
}

/* css for ie */

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .breadcrumb1-share li:last-child {
      flex: 1 0 auto;
      min-width: 50px;
   }
}

/* ------------- */

.breadcrumb1-share a {
   cursor: pointer;
}

.breadcrumb1-share a, .breadcrumb1-share span {
   overflow: hidden;
   text-overflow: ellipsis;
}

.breadcrumb1-share li:not(:last-child):after {
   content: "\\f105";
   font-family: FontAwesome, sans-serif;
   padding: 0 5px;
   line-height: 32px;
   vertical-align: baseline;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer/viewer.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,YAAY;GACZ,sBAAsB;AACzB;AACA;GACG,uBAAuB;GACvB,YAAY;GACZ,8BAA8B;GAC9B,eAAe;GACf,aAAa;GACb,WAAW;GACX,YAAY;AACf;;AAEA;GACG,yBAAyB;AAC5B;AACA;GACG,gBAAgB;AACnB;AACA;GACG,iBAAiB;GACjB,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,eAAe;GACf,gBAAgB;AACnB;AACA;GACG,WAAW;AACd;AACA;GACG,cAAc;GACd,YAAY;GACZ,qBAAqB;AACxB;AACA;GACG,YAAY;AACf;AACA;GACG,yBAAyB;GACzB,YAAY;GACZ,WAAW;GACX,YAAY;AACf;AACA;GACG,yBAAyB;GACzB,YAAY;GACZ,WAAW;GACX,UAAU;AACb;AACA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,WAAW;AACd;AACA;GACG,gBAAgB;AACnB;AACA;GACG,WAAW;GACX,mBAAmB;AACtB;AACA;GACG,YAAY;GACZ,WAAW;GACX,mBAAmB;AACtB;AACA;GACG,YAAY;AACf;AACA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,cAAc;AACjB;AACA;GACG,cAAc;GACd,eAAe;AAClB;AACA,sBAAsB;GACnB,kBAAkB;AACrB,IAAI;AACJ;GACG,WAAW;AACd;AACA;GACG,UAAU;AACb;AACA;GACG,iBAAiB;AACpB;AACA;GACG,gBAAgB;GAChB,yBAAyB;GACzB,kBAAkB;GAClB,yCAAyC;GACzC,gBAAgB;GAChB,qBAAqB;AACxB;AACA;GACG,yBAAyB;GACzB,kBAAkB;AACrB;AACA;GACG,YAAY;GACZ,cAAc;GACd,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,kBAAkB;AACrB;AACA;GACG,uBAAuB;AAC1B;AACA;GACG,eAAe;GACf,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;AACA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;AACA;GACG,cAAc;AACjB;AACA;GACG,aAAa;AAChB;AACA;GACG,WAAW;AACd;;;AAGA;GACG,gBAAgB;GAChB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,4BAA4B;AAC/B;AACA;GACG,gCAAgC;GAChC,WAAW;GACX,oBAAoB;GACpB,mBAAmB;AACtB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,SAAS;GACT,UAAU;AACb;AACA;GACG,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;AACnB;AACA;;GAEG,WAAW;GACX,cAAc;GACd,gBAAgB;GAChB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,gBAAgB;GAChB,qBAAqB;AACxB;AACA;;GAEG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,gBAAgB;GAChB,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,oBAAoB;GACpB,mBAAmB;GACnB,WAAW;AACd;AACA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,iBAAiB;AACpB;AACA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,cAAc;AACjB;;;AAGA;GACG,WAAW;AACd;AACA;GACG,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;AACjB;AACA;GACG,OAAO;AACV;AACA;GACG,aAAa;GACb,sBAAsB;GACtB,oBAAoB;AACvB;AACA;GACG,oCAA2D;GAC3D,sBAAsB;AACzB;AACA;GACG,cAAc;AACjB;AACA;GACG,aAAa;AAChB;;AAEA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;AAClB;AACA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,eAAe;GACf,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;GAChB,uBAAuB;GACvB,cAAc;AACjB;AACA;GACG,WAAW;GACX,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,cAAc;AACjB;AACA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,eAAe;GACf,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,iBAAiB;GACjB,oBAAoB;AACvB;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,oBAAoB;GACpB,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;AACA;GACG,kBAAkB;GAClB,aAAa;GACb,SAAS;AACZ;AACA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;AACA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;AACA;GACG,YAAY;GACZ,cAAc;AACjB;AACA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;AACA;GACG,eAAe;GACf,YAAY;AACf;AACA;GACG,aAAa,EAAE,SAAS;GACxB,wBAAwB;GACxB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,oBAAoB;GACpB,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,kBAAkB;AACrB;AACA;GACG,WAAW;GACX,sBAAsB;GACtB,eAAe;GACf,kBAAkB;GAClB,aAAa;GACb,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,mBAAmB;AACtB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;AACX;AACA;GACG,qBAAqB;GACrB;AACH;AACA;GACG,iBAAiB;AACpB;AACA;GACG,iBAAiB;GACjB,qBAAqB;GACrB,qBAAqB;AACxB;AACA;GACG,kBAAkB;AACrB;;AAEA;GACG,sBAAsB;GACtB,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,YAAY;GACZ,aAAa;GACb,WAAW;GACX,sBAAsB;AACzB;AACA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,2BAA2B;AAC9B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,uCAAuC;GACvC,WAAW;AACd;;AAEA;GACG,WAAW;GACX,eAAe;GACf,gBAAgB;GAChB,SAAS;GACT,UAAU;GACV,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;GAChB,YAAY;GACZ,sBAAsB;GACtB,mBAAmB;GACnB,yEAAyE;AAC5E;AACA;GACG,uBAAuB;GACvB,YAAY;GACZ,wBAAwB;GACxB,eAAe;GACf,aAAa;GACb,WAAW;GACX,YAAY;AACf;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,mBAAmB;GACnB,SAAS;GACT,UAAU;GACV,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,iBAAiB;GACjB,YAAY;AACf;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,eAAe;GACf,qBAAqB;GACrB,uBAAuB;GACvB,gBAAgB;GAChB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,OAAO;GACP,QAAQ;GACR,SAAS;GACT,oBAAoB;GACpB,YAAY;AACf;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;GACnB,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,OAAO;GACP,eAAe;AAClB;;AAEA,eAAe;;AAEf;GACG;MACG,cAAc;MACd,eAAe;GAClB;AACH;;AAEA,kBAAkB;;AAElB;GACG,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;GAChB,oCAAoC;GACpC,cAAc;GACd,iBAAiB;GACjB,wBAAwB;AAC3B","sourcesContent":[".preview-header {\n   background: #2ab4c0;\n   height: 60px;\n   padding: 0 15px 0 10px;\n}\n.preview-header .back-button {\n   background: transparent;\n   border: none;\n   color: rgba(255, 255, 255, .7);\n   cursor: pointer;\n   outline: none;\n   width: 32px;\n   height: 32px;\n}\n\n.file-action {\n   justify-content: flex-end;\n}\n.file-action button + button {\n   margin-left: 1em;\n}\n.file-action button.mat-button, .file-action button.mat-raised-button {\n   line-height: 28px;\n   min-width: 80px;\n   padding: 0 12px;\n}\n\n.image-viewer {\n   overflow: auto;\n}\n.image-viewer img {\n   background: #fff;\n   max-width: 100%;\n   max-height: 100%;\n}\n.image-viewer::ng-deep svg {\n   width: 100%;\n}\n.text-viewer {\n   overflow: auto;\n   padding: 1em;\n   white-space: pre-wrap;\n}\n.mail-viewer {\n   padding: 1em;\n}\n.mail-viewer table, .mail-viewer iframe {\n   border-collapse: collapse;\n   border: none;\n   width: 100%;\n   height: 100%;\n}\niframe {\n   border-collapse: collapse;\n   border: none;\n   width: 100%;\n   z-index: 1;\n}\n.mail-viewer td:first-child {\n   padding: 3px 5px;\n   text-align: right;\n   width: 80px;\n}\n.mail-viewer td:last-child {\n   padding: 3px 5px;\n}\n.address::ng-deep b {\n   color: #222;\n   font-weight: normal;\n}\n.mail-viewer .body {\n   height: 100%;\n   width: 100%;\n   vertical-align: top;\n}\n.mail-viewer td.attachment {\n   padding: 3px;\n}\n.mail-viewer .attachment div {\n   display: inline-block;\n   margin-right: 1em;\n   line-height: 2;\n}\n.mail-viewer a {\n   color: #ba68c8;\n   cursor: pointer;\n}\n/*::ng-deep .body a {*/\n   /*color: #2ab4c0;*/\n/*}*/\n.mail-viewer td:first-child {\n   color: #222;\n}\n.mail-viewer td.text {\n   padding: 0;\n}\n.mail-viewer td.html {\n   padding: 10px 0 0;\n}\n.mail-viewer .subject, .mail-viewer .fit {\n   background: #fff;\n   border: 1px solid #ececec;\n   border-radius: 3px;\n   box-shadow: inset 0 0 6px rgba(0,0,0,.05);\n   padding: 3px 5px;\n   white-space: pre-wrap;\n}\n.body iframe {\n   border: 1px solid #f4f5f7;\n   border-radius: 3px;\n}\n.mail-viewer .fit {\n   height: 100%;\n   overflow: auto;\n   padding: .5em 1em;\n}\naudio {\n   min-width: 80%;\n   visibility: hidden;\n}\n.video-viewer {\n   background-color: black;\n}\nvideo {\n   max-width: 100%;\n   max-height: 100%;\n   visibility: hidden;\n}\n.visible {\n   visibility: visible;\n}\n\n.can-not-preview {\n   padding: 2em;\n   text-align: center;\n}\n.preview-icon {\n   opacity: .7;\n   width: 160px;\n   height: 160px;\n   margin: auto;\n}\n.preview-error {\n   color: #1b2733;\n   font-size: 18px;\n   margin: 8px;\n}\n.preview-error-info {\n   color: #637282;\n}\n.preview-error-info span {\n   margin: 0 8px;\n}\n.can-not-preview button {\n   margin: 8px;\n}\n\n\n.info {\n   background: #fff;\n   width: 320px;\n   min-width: 320px;\n   overflow-y: auto;\n   transition: margin-right .2s;\n}\n.section-header {\n   border-bottom: 1px solid #eaeaea;\n   color: #222;\n   padding-bottom: 10px;\n   margin: 30px 0 10px;\n}\n.info .properties {\n   font-size: 13px;\n   line-height: 16px;\n   margin: 0;\n   padding: 0;\n}\n.info .edit {\n   color: #2ab4c0;\n   cursor: pointer;\n   font-size: 13px;\n   font-weight: 300;\n}\n.info label,\n.info dl dt {\n   color: #777;\n   display: block;\n   margin: 20px 0 0;\n   padding-bottom: 3px;\n}\n.info dl dd {\n   color: #444;\n   margin: 0 0 20px;\n   word-break: break-all;\n}\n.info input,\n.info textarea {\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   font-size: 13px;\n   outline: none;\n   padding: 3px 6px;\n   resize: none;\n   width: 100%;\n}\n\n.select-types {\n   padding-bottom: 10px;\n   margin: 30px 0 10px;\n   width: 100%;\n}\n.save-metadata {\n   margin-top: 20px;\n   text-align: right;\n   margin-right: 5px;\n}\n.save-button {\n   line-height: 1.7;\n   min-width: inherit;\n   padding: 0 1em;\n}\n\n\nmat-tab-group {\n   width: 100%;\n}\n.info::ng-deep .mat-tab-label {\n   height: auto;\n   line-height: 36px;\n   min-width: inherit;\n   padding: 0 1em;\n}\n.info::ng-deep .mat-tab-body-wrapper {\n   flex: 1;\n}\n.info::ng-deep .mat-tab-body-content {\n   display: flex;\n   flex-direction: column;\n   padding: 0 0 1em 1em;\n}\n.example-header-image {\n   background-image: url('../../../assets/images/profile.png');\n   background-size: cover;\n}\n.commentItem:hover .delComment {\n   display: block;\n}\n.delComment {\n   display: none;\n}\n\n.comments-container {\n   overflow-y: auto;\n}\n.no-comment {\n   padding: 1em;\n}\n.comments-container ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.comments-container li {\n   margin-top: 1em;\n}\n.comment-item {\n   line-height: 20px;\n   margin-left: 48px;\n   position: relative;\n}\n.comment-item a {\n   cursor: pointer;\n   white-space: nowrap;\n   width: 200px;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   display: block;\n}\n.comment-item .avatar {\n   float: left;\n   margin-left: -48px;\n   margin-top: 3px;\n   width: 36px;\n   height: 36px;\n   border-radius: 50%;\n   object-fit: cover;\n}\n.comment-item .time {\n   color: #657786;\n   font-size: 12px;\n}\n.comment-item .time:before {\n   content: \"\\00b7\";\n   padding: 0 5px;\n}\n.comment-item .delete {\n   color: #999;\n   cursor: pointer;\n   position: absolute;\n   top: 0;\n   right: 0;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   display: none;\n}\n.comment-item:hover .delete {\n   display: block;\n}\n.comment-item .delete:hover {\n   color: #d32f2f;\n}\n.add-comment {\n   text-align: right;\n   margin: 5px 10px 0 0;\n}\n.add-comment textarea {\n   display: block;\n}\n.add-comment button {\n   margin-top: .5em;\n   padding: 1px 16px;\n   line-height: initial;\n   min-width: 64px;\n}\n\n.relative {\n   position: relative;\n}\n.page-notfound {\n   text-align: center;\n   padding: 10em;\n   height: 0;\n}\n.page-notfound-error {\n   color: #1b2733;\n   font-size: 30px;\n   margin: 8px;\n}\n.page-notfound-icon {\n   opacity: .7;\n   width: 200px;\n   height: 200px;\n   margin: auto;\n}\n.page-notfound input {\n   padding: 8px;\n   margin: 10px 0;\n}\n.page-password-icon {\n   opacity: .7;\n   width: 200px;\n   height: 200px;\n   margin: auto;\n}\n.page-password-text {\n   font-size: 18px;\n   margin: 10px;\n}\n.img-center {\n   display: flex; /*for IE*/\n   /*display: -webkit-box;*/\n   align-items: center;\n   justify-content: center;\n}\n\n.slide-right {\n   margin-right: -320px;\n   display: none;\n}\n\n.editing .item-content, .textarea-content {\n   display: none;\n}\n.editing .textarea-content {\n   display: block;\n}\n.textarea-content {\n   margin-top: 5px;\n   margin-right: 10px;\n}\n.edit2, .delete2 {\n   color: #999;\n   vertical-align: middle;\n   font-size: 16px;\n   text-align: center;\n   display: none;\n   cursor: pointer;\n}\n.delete2:hover {\n   color: #d32f2f;\n}\n.edit2:hover {\n   color: #00bed6;\n}\n.comment-item:hover .delete2, .comment-item:hover .edit2  {\n   display: table-cell;\n}\n.mat-button {\n   min-width: 0px;\n}\n.mat-button.save {\n   color: #00bed6;\n}\n.textarea-content div {\n   text-align: right;\n}\n.btn-comment {\n   position: absolute;\n   top: 0;\n   right: 0;\n}\n.item-content {\n   word-wrap: break-word;\n   white-space: pre-line\n}\n.form {\n   margin-right: 5px;\n}\n.author-name {\n   margin-right: 4em;\n   word-wrap: break-word;\n   white-space: pre-line;\n}\n.description {\n   margin-right: 10px;\n}\n\n.empty-folder-share {\n   flex-direction: column;\n   margin-right: 2em;\n   text-align: center;\n}\n.empty-folder-share img {\n   width: 150px;\n   height: 150px;\n   opacity: .6;\n   filter: grayscale(10%);\n}\n.empty-folder-share h4 {\n   font-size: 20px;\n   margin: 0 0 10px;\n}\n\n.browse-folder {\n   display: inline-block;\n   margin-right: 5px;\n   width: 24px;\n   height: 24px;\n   vertical-align: text-bottom;\n}\n\n.menu-share {\n   list-style: none;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu-share>li {\n   float: left;\n}\n\n.menu-share>li+li {\n   margin-left: 1em;\n}\n\n.menu-share>li>a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu-share>li>a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open>a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu-share i {\n   font-size: 16px;\n}\n\n.menu-share i+span {\n   margin-left: 10px;\n}\n\n.menu-share span+i {\n   margin-left: 10px;\n}\n\n.menu-share button {\n   min-width: 0;\n   padding: 0 12px;\n}\n\n.menu-share button.mat-primary {\n   line-height: 30px;\n}\n\n.menu-share button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.drag-over {\n   background-color: rgba(0, 188, 212, .2);\n   opacity: .5;\n}\n\n.bc-view-share {\n   color: #fff;\n   font-size: 16px;\n   font-weight: 400;\n   margin: 0;\n   padding: 0;\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.preview-header-share {\n   background: #fff;\n   height: 60px;\n   padding: 0 15px 0 10px;\n   align-items: center;\n   box-shadow: #0000000d 0 1px 2px, #0000000d 0 1px 4px, #0000000d 0 2px 8px;\n}\n.preview-header-share .back-button {\n   background: transparent;\n   border: none;\n   color: rgba(0, 0, 0, .4);\n   cursor: pointer;\n   outline: none;\n   width: 32px;\n   height: 32px;\n}\n\n.doc-title-modified-share {\n   font-size: 12px;\n   margin-top: 3px;\n}\n\n.doc-title-share {\n   margin: 0 15px 0 10px;\n}\n\n.doc-title-share h1 {\n   font-size: 16px;\n   font-weight: normal;\n   margin: 0;\n   padding: 0;\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.img-logo {\n   margin-left: 10px;\n   height: 24px;\n}\n\n.img-logo.custom {\n   height: 32px;\n}\n\n.sidebar-toggle-share {\n   cursor: pointer;\n   display: inline-block;\n   fill: rgba(0, 0, 0, .5);\n   margin-left: 1em;\n   min-width: 12px;\n   min-height: 10px;\n}\n\n.powered-by {\n   position: fixed;\n   left: 0;\n   right: 0;\n   bottom: 0;\n   transition: left .4s;\n   z-index: 999;\n}\n\n.breadcrumb1-share {\n   font-size: 18px;\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n   color: rgba(0, 0, 0, .5);\n}\n\n.breadcrumb1-share li:first-child {\n   display: inline-block;\n   white-space: nowrap;\n}\n\n.breadcrumb1-share li:not(:first-child) {\n   overflow: hidden;\n}\n\n.breadcrumb1-share li:last-child {\n   flex: 1;\n   min-width: 50px;\n}\n\n/* css for ie */\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n   .breadcrumb1-share li:last-child {\n      flex: 1 0 auto;\n      min-width: 50px;\n   }\n}\n\n/* ------------- */\n\n.breadcrumb1-share a {\n   cursor: pointer;\n}\n\n.breadcrumb1-share a, .breadcrumb1-share span {\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.breadcrumb1-share li:not(:last-child):after {\n   content: \"\\f105\";\n   font-family: FontAwesome, sans-serif;\n   padding: 0 5px;\n   line-height: 32px;\n   vertical-align: baseline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
